import { POST_PROPERTYTYPES, LIST_PROPERTYTYPES } from '../actionTypes/propertytypes';

const BASE = {
  state: false,
  data: null,
};

const BASE_PAGINATION = {
  state: false,
  data: {
    total: 0,
    list: [],
  },
};

export const INITIAL_STATE = {
  statePostPropertyTypes: BASE,
  listPropertyTypes: BASE_PAGINATION,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case POST_PROPERTYTYPES:
      return { ...state, statePostPropertyTypes: action.payload };
    case LIST_PROPERTYTYPES:
      return { ...state, listPropertyTypes: action.payload };
    default:
      return state;
  }
};
